<template>
  <v-app-bar app elevation="3">
    <img
      :src="$i18n.locale === 'el' || $i18n.locale === 'gr' ? require('@/assets/logo.svg') : require('@/assets/bibliotheca.png')"
      class="logo mr-auto"
      :class="{ 
        'in-room': inRoom, 
        'bibliotheca-style': $i18n.locale !== 'el' && $i18n.locale !== 'gr' 
      }"
      @click="
        !inRoom &&
          $router.push({ path: `${role == 'superuser' ? '/superuser' : '/'}` })
      "
    />

    <v-btn
      rounded
      outlined
      small
      color="primary"
      class="mr-2"
      @click="$router.push({ path: '/shadow' })"
      v-if="!inRoom && isLoggedIn && role == 'superuser'"
    >
      <v-icon left small>mdi-eye</v-icon>
      {{ $t('watchPresentation') }}
    </v-btn>

    <v-btn rounded outlined small depressed color="primary" v-if="isLoggedIn" @click="onLogout"
    >{{ $t('logout') }}
    <v-icon right small> mdi-logout </v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState({
      role: (state) => state.auth.role,
    }),
    inRoom() {
      return this.$route.path.includes("/room/");
    },
  },
watch: {
  '$i18n.locale': {
    immediate: true,
    handler(newLocale) {
      const isGreek = newLocale === 'el' || newLocale === 'gr';
      
      // 1. ΑΛΛΑΓΗ ΤΙΤΛΟΥ
      document.title = isGreek ? "Museotek Admin" : "Bibliotheca Admin";

      // 2. ΑΛΛΑΓΗ ΕΙΚΟΝΙΔΙΟΥ
      // Δοκιμάζουμε να τραβήξουμε τα αρχεία με require για να τα κάνει σωστά compile το Webpack
      try {
        const iconPath = isGreek 
          ? require('@/public/favicon.png') // Ή το favicon.png σου
          : require('../../public/bibliotheca.png');

        let link = document.querySelector("link[rel*='icon']");
        
        if (!link) {
          link = document.createElement('link');
          link.rel = 'shortcut icon';
          document.getElementsByTagName('head')[0].appendChild(link);
        }
        
        link.href = iconPath;
      } catch (e) {
        console.error("Σφάλμα στην φόρτωση του εικονιδίου:", e);
      }
    }
  }
},
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setAllowLeave"]),
    async onLogout() {
      await this.logout();
      if (this.inRoom) {
        this.setAllowLeave(true);
      }
      this.$router.push({ path: `/${this.$i18n.locale}/login` });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 28px;
  width: auto;
  transition: all 0.2s ease-in-out;

  &.bibliotheca-style {
    height: 45px; 
    margin-top: -5px;
  }

  &:not(.in-room) {
    cursor: pointer;
  }

  img {
    cursor: pointer;
  }
}
</style>